import Section1 from "./components/Section1";
import Section2 from "./components/Section2";
import Section3 from "./components/Section3";
import Section4 from "./components/Section4";
import Section5 from "./components/Section5";
import Section6 from "./components/Section6";
import Section7 from "./components/Section7";
import Section8 from "./components/Section8";
import Section9 from "./components/Section9";
import Footer from "./components/Footer";
import Header from "../../components/feature/Header";

export default function HomePage() {
  return (
    <>
      <Header />
      <div className="relative w-full min-h-screen overflow-hidden">
        <Section1 />
        <Section2 />
        <Section3 />
        <Section4 />
        <div
          className="relative w-full"
          style={{
            background:
              "linear-gradient(to bottom, #000000 0%, #000000 20%, #ffffff 50%, #000000 80%, #000000 100%)",
          }}
        >
          <Section5 />
          <Section6 />
          <Section7 />
        </div>
        <Section8 />
        <Section9 />
        <Footer />
      </div>
    </>
  );
}
